/* eslint-disable */
// Usage  https://github.com/Hzy0913/utils
export function formatDate(time, format) {
  time = new Date(time);
  const o = {
    'M+': time.getMonth() + 1,
    'd+': time.getDate(),
    'h+': time.getHours(),
    'm+': time.getMinutes(),
    's+': time.getSeconds(),
    'q+': Math.floor((time.getMonth() + 3) / 3),
    'S': time.getMilliseconds()
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return format;
}

export function formatMoney(num, digit, mode) {
  var powNumber = Math.pow(10, digit);
  var money;
  if (mode === 'ceil') {
    money = Math.ceil(num * powNumber) / powNumber;
  } else if (mode === 'floor') {
    money = Math.floor(num * powNumber) / powNumber;
  } else {
    money = Math.round(num * powNumber) / powNumber;
  }
  var numStr = money.toString();
  var numArr = numStr.split('.');
  var integer = numArr[0];
  var decimal = numArr[1] || '';
  var decimalLength = decimal.length;
  for (var i = 0; i < (digit - decimalLength); i++) {
    decimal += '0';
  }
  money = String(integer).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (digit) {
    money = money + '.' + decimal;
  }
  return money;
}

export function generatorClass(className, addClassName = '') {
  if (typeof addClassName === 'string') {
    return [className, addClassName].join(' ').trim();
  }
  return [className, ...addClassName].join(' ').trim();
}
